module.exports = __webpack_public_path__ + "6632fa6df5147e0414a462b1a122ef54.jpg";